import { render } from "./BackSteps.vue?vue&type=template&id=bb4c1200&scoped=true&ts=true"
import script from "./BackSteps.vue?vue&type=script&lang=ts"
export * from "./BackSteps.vue?vue&type=script&lang=ts"

import "./BackSteps.vue?vue&type=style&index=0&id=bb4c1200&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb4c1200"]])

export default __exports__